export default __webpack_public_path__ + "static/media/8c3fbe094501f817a2c9ff94ae534ea4.png";